import { updateCarId, selectAllCar, insertCar, updateCar, deleteCar, batchTransferCar, carBindDriver, uploadCar,queryCarTrajectory,carReplaceTerminal,getCarId } from "../../api/config/modules/VehicleFiles";

const state = {
    selectAllCar: {},
    insertCar: {},
    updateCar: {},
    deleteCar: {},
    batchTransferCar: {},
    carBindDriver: {},
    uploadCar: {},
    queryCarTrajectory: {},
    carReplaceTerminal: {},
    updateCarId: {},
    getCarId: {}
};

const mutations = {
    SET_SELECTALLCAR: (state, selectAllCar) => {
        state.selectAllCar = selectAllCar;
    },
    SET_INSERTCAR: (state, insertCar) => {
        state.insertCar = insertCar;
    },
    SET_UPDATECAR: (state, updateCar) => {
        state.updateCar = updateCar;
    },
    SET_DELETECAR: (state, deleteCar) => {
        state.deleteCar = deleteCar;
    },
    SET_BATCHCAR: (state, batchTransferCar) => {
        state.batchTransferCar = batchTransferCar;
    },
    SET_CARBIND: (state, carBindDriver) => {
        state.carBindDriver = carBindDriver;
    },
    SET_: (state, uploadCar) => {
        state.uploadCar = uploadCar;
    },
    SET_CARTRAJECTORY: (state, queryCarTrajectory) => {
        state.queryCarTrajectory = queryCarTrajectory;
    },
    SET_CARREPLACETERMINAL: (state, carReplaceTerminal) => {
        state.carReplaceTerminal = carReplaceTerminal;
    },
    SET_UPDATECARID: (state, updateCarId) => {
        state.updateCarId = updateCarId;
    },
    SET_GETCARID: (state, getCarId) => {
        state.getCarId = getCarId;
    },
};

const actions = {
    GET_SELECTALLCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllCar(data)
                .then((res) => {
                    commit("SET_SELECTALLCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertCar(data)
                .then((res) => {
                    commit("SET_INSERTCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATECAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateCar(data)
                .then((res) => {
                    commit("SET_UPDATECAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETECAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteCar(data)
                .then((res) => {
                    commit("SET_DELETECAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_BATCHCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            batchTransferCar(data)
                .then((res) => {
                    commit("SET_BATCHCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_CARBIND: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            carBindDriver(data)
                .then((res) => {
                    commit("SET_CARBIND", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPLOADCAR: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            uploadCar(data)
                .then((res) => {
                    commit("SET_UPLOADCAR", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_CARTRAJECTORY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryCarTrajectory(data)
                .then((res) => {
                    commit("SET_CARTRAJECTORY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_CARREPLACETERMINAL: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            carReplaceTerminal(data)
                .then((res) => {
                    commit("SET_CARREPLACETERMINAL", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATECARID: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateCarId(data)
                .then((res) => {
                    commit("SET_UPDATECARID", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETCARID: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCarId(data)
                .then((res) => {
                    commit("SET_GETCARID", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
